import { toZonedTime } from 'date-fns-tz';

export interface VenueLocale {
  locale: string;
  timezone: string;
  currency: string;
}

function toDate(iso: string | Date): Date {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime())) {
    throw new Error(`Invalid date input: ${String(iso)}`);
  }
  return d;
}

export function formatDateInVenue(
  iso: string | Date,
  venue: Pick<VenueLocale, 'locale' | 'timezone'>,
  options: Intl.DateTimeFormatOptions = { dateStyle: 'medium' },
): string {
  const date = toDate(iso);
  return new Intl.DateTimeFormat(venue.locale, {
    ...options,
    timeZone: venue.timezone,
  }).format(date);
}

export function formatTimeInVenue(
  iso: string | Date,
  venue: Pick<VenueLocale, 'locale' | 'timezone'>,
  options: Intl.DateTimeFormatOptions = { timeStyle: 'short' },
): string {
  const date = toDate(iso);
  return new Intl.DateTimeFormat(venue.locale, {
    ...options,
    timeZone: venue.timezone,
  }).format(date);
}

export function zonedDateInVenue(iso: string | Date, venue: Pick<VenueLocale, 'timezone'>): Date {
  return toZonedTime(toDate(iso), venue.timezone);
}
